/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccessMetaDataResponse } from './AccessMetaDataResponse';
import {
    AccessMetaDataResponseFromJSON,
    AccessMetaDataResponseFromJSONTyped,
    AccessMetaDataResponseToJSON,
    AccessMetaDataResponseToJSONTyped,
} from './AccessMetaDataResponse';

/**
 * 
 * @export
 * @interface UserClaimsResponse
 */
export interface UserClaimsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserClaimsResponse
     */
    roles?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserClaimsResponse
     */
    permissions?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserClaimsResponse
     */
    globalRoles?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserClaimsResponse
     */
    globalPermissions?: Array<string> | null;
    /**
     * 
     * @type {Array<AccessMetaDataResponse>}
     * @memberof UserClaimsResponse
     */
    accessMetaData?: Array<AccessMetaDataResponse> | null;
    /**
     * 
     * @type {Date}
     * @memberof UserClaimsResponse
     */
    lastChangeTime?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof UserClaimsResponse
     */
    anyDependencyRequiresMfa?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserClaimsResponse
     */
    anyDependencyRequiresIdPortenMfa?: boolean;
}

/**
 * Check if a given object implements the UserClaimsResponse interface.
 */
export function instanceOfUserClaimsResponse(value: object): value is UserClaimsResponse {
    return true;
}

export function UserClaimsResponseFromJSON(json: any): UserClaimsResponse {
    return UserClaimsResponseFromJSONTyped(json, false);
}

export function UserClaimsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserClaimsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'roles': json['roles'] === undefined ? undefined : json['roles'] === null ? null : json['roles'],
        'permissions': json['permissions'] === undefined ? undefined : json['permissions'] === null ? null : json['permissions'],
        'globalRoles': json['globalRoles'] === undefined ? undefined : json['globalRoles'] === null ? null : json['globalRoles'],
        'globalPermissions': json['globalPermissions'] === undefined ? undefined : json['globalPermissions'] === null ? null : json['globalPermissions'],
        'accessMetaData': json['accessMetaData'] === undefined ? undefined : json['accessMetaData'] === null ? null : ((json['accessMetaData'] as Array<any>).map(AccessMetaDataResponseFromJSON)),
        'lastChangeTime': json['lastChangeTime'] == null ? undefined : (new Date(json['lastChangeTime'])),
        'anyDependencyRequiresMfa': json['anyDependencyRequiresMfa'] == null ? undefined : json['anyDependencyRequiresMfa'],
        'anyDependencyRequiresIdPortenMfa': json['anyDependencyRequiresIdPortenMfa'] == null ? undefined : json['anyDependencyRequiresIdPortenMfa'],
    };
}

export function UserClaimsResponseToJSON(json: any): UserClaimsResponse {
    return UserClaimsResponseToJSONTyped(json, false);
}

export function UserClaimsResponseToJSONTyped(value?: UserClaimsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roles': value['roles'],
        'permissions': value['permissions'],
        'globalRoles': value['globalRoles'],
        'globalPermissions': value['globalPermissions'],
        'accessMetaData': value['accessMetaData'] == null ? undefined : ((value['accessMetaData'] as Array<any>).map(AccessMetaDataResponseToJSON)),
        'lastChangeTime': value['lastChangeTime'] == null ? value['lastChangeTime'] : value['lastChangeTime'].toISOString(),
        'anyDependencyRequiresMfa': value['anyDependencyRequiresMfa'],
        'anyDependencyRequiresIdPortenMfa': value['anyDependencyRequiresIdPortenMfa'],
    };
}

